import { HomeContainer } from "components/UI/atoms";
import "./index.scss";
import { EducationCard } from "components/UI/molecules";
import { INTERNAL_PATHS } from "routes/paths";

export const HomeEducationCards = () => (
  <HomeContainer>
    <div className="home-education-cards">
      <div className="education-cards-container">
        <div className="education-cards-header">
          <h1 className="title">
            Save More with GCX Gift Cards
          </h1>
        </div>
        <div>
          <div className="education-cards-list">
            <EducationCard
              title="DISCOUNT"
              description="Buy discounted gift cards and save up to 30% at thousands of your favorite stores."
              buttonText="SAVE NOW"
              linkTo={INTERNAL_PATHS.BUY_GIFT_CARDS}
            />
            <hr className="education-cards-spacer tablet" />
            <EducationCard
              title="GCX Cash"
              description="Buy full-priced gift cards and get up to 15% back in GCX Cash to spend on future purchases."
              buttonText="EARN NOW"
              linkTo={INTERNAL_PATHS.SHOP_CASHBACK}
            />
          </div>
        </div>
      </div>
    </div>
  </HomeContainer>
);
